import React from 'react';
export function Eyebrow({
  children,
  danger = false,
  onDark = false
}: {
  children: React.ReactNode;
  danger?: boolean;
  onDark?: boolean;
}) {
  const color = danger ? onDark ? 'text-red-300' : 'text-red-600' : onDark ? 'text-amber-400' : 'text-yellow-700';
  return <p className={`mb-3 text-center text-[11px] font-extrabold uppercase tracking-[.16em] md:text-sm ${color}`} data-id="element-395" data-mp="2r62i3zmie3g6">
      {children}
    </p>;
}
export function SectionTitle({
  children,
  onDark = false
}: {
  children: React.ReactNode;
  onDark?: boolean;
}) {
  return <h2 className={`mx-auto max-w-3xl text-center text-2xl font-black uppercase leading-tight md:text-4xl ${onDark ? 'text-white' : 'text-blue-950'}`} data-id="element-396" data-mp="30y8a39crgkvd">
      {children}
    </h2>;
}
export function Highlight({
  children
}: {
  children: React.ReactNode;
}) {
  return <span className="box-decoration-clone rounded bg-amber-300 px-1.5 text-blue-950" data-id="element-397" data-mp="1khvy21uu9f2z">
      {children}
    </span>;
}
export function SectionLead({
  children,
  onDark = false
}: {
  children: React.ReactNode;
  onDark?: boolean;
}) {
  return <p className={`mx-auto mt-3 max-w-2xl text-center text-sm font-semibold leading-relaxed md:text-base ${onDark ? 'text-slate-300' : 'text-slate-600'}`} data-id="element-398" data-mp="29jtgbqiu3xxm">
      {children}
    </p>;
}